import httpClient from "./httpClient";

const base = "/public/online-fee-payment";

/**
 * Public SSLCommerz checkout endpoints (Phase 9 backend, first given a
 * frontend consumer here in Phase 10 via the student portal). See
 * OnlineFeePaymentController javadoc — a real session/validate call moves
 * real money, so this is only ever invoked from the student-portal "Pay
 * Online" button behind an explicit confirmation.
 */
export function previewPayableFees(payload) {
  return httpClient.post(`${base}/payable-preview`, payload).then((res) => res.data.data);
}

export function createSession(payload) {
  return httpClient.post(`${base}/session`, payload).then((res) => res.data.data);
}

export function validatePayment(payload) {
  return httpClient.post(`${base}/validate`, payload).then((res) => res.data.data);
}
